export default __webpack_public_path__ + "c966de50084af9f75047b866c5a40ade.svg";